module.exports = __webpack_public_path__ + "img/swiper.b4f66898.png";